/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonCompetenceViewModel } from "../types/PersonCompetenceViewModel.ts";

export const personCompetenceViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  competenceId: z.optional(z.number().int()),
}) as unknown as ToZod<PersonCompetenceViewModel>;
